export default [ 
		{ 
				text: 'Producto',
				value: 'product',
				sortable: true
		},
		{ 
				text: 'UPC',
				value: 'upc',
				sortable: true
		},
		{ 
				text: 'Porcentaje Descuento',
				value: 'percentage',
				sortable: true
		},
		{ 
				text: 'Precio Normal',
				value: 'sale_price',
				sortable: true
		},
		{ 
				text: 'Precio Oferta',
				value: 'offer_price',
				sortable: true
		},
]
